import { PayItemsSummary } from '../../../cimsPage/instances/payItems'
import { BasicPermissionItem } from '../../PermissionItem'

const summary = 'Pay Item Summary'

export const ViewPayItemSummary = new BasicPermissionItem({
  id: '1ABA74BB-7782-42DA-A777-3499C0DD3BDE',
  action: 'view the Pay Item Summary',
  allowMixedCase: true,
  page: PayItemsSummary,
  name: `View ${summary}`,
  crud: 'View',
})
export const EditPayItemSummary = new BasicPermissionItem({
  id: '3A741DE0-71C9-4836-90BA-FF9BB56D04D2',
  action: 'edit the Pay Item Summary',
  allowMixedCase: true,
  page: PayItemsSummary,
  name: `Edit ${summary}`,
  crud: 'Edit',
})

export type PayItemsSummaryPermission =
  | typeof ViewPayItemSummary
  | typeof EditPayItemSummary
